import BankIDIcon from "@/images/bankid/icon/svg/DNA-element-white.svg";
import css from "./BankIDLink.module.scss";

// These are the only valid labels we can use for this button.
const LABELS = {
  "log-in-with-bankid": {
    nb: "Logg inn med BankID",
    en: "Log in with BankID",
  },
  "continue-with-bankid": {
    nb: "Fortsett med BankID",
    en: "Continue with BankID",
  },
  "register-with-bankid": {
    nb: "Registrer med BankID",
    en: "Register with BankID",
  },
  "sign-with-bankid": {
    nb: "Signer med BankID",
    en: "Sign with BankID",
  },
  "authenticate-with-bankid": {
    nb: "Autentiser med BankID",
    en: "Authenticate with BankID",
  },
  "approve-with-bankid": {
    nb: "Godkjenn med BankID",
    en: "Approve with BankID",
  },
} as const;

// The styling and behavior of this component is based on BankID's design manual.
// See https://bankid.no/bedrift/designmanual-knapper
export function BankIDLink({
  type,
  ...linkProps
}: Omit<React.ComponentProps<"a">, "className"> & {
  type: keyof typeof LABELS;
}) {
  const label = LABELS[type].nb;

  return (
    <a className={css.button} {...linkProps}>
      <BankIDIcon className={css.icon} />
      <span className={css.text}>{label}</span>
    </a>
  );
}
